import { useEffect, useState } from 'react';
import { intervalToDuration, isFuture, Duration } from "date-fns";

export const leadingZero = (v: number) => ("00" + v).substr(-2);

const formatDefault = (d: Duration) => {
  return `${leadingZero(d.minutes ?? 0)}:${leadingZero(d.seconds ?? 0)}`
}

function Timer({ endDate, format }: {
  endDate: string | Date,
  format?: (d: Duration) => string,
}) {
  const [timer, setTimer] = useState("");

  useEffect(() => {
    handlerStartTimer();
  }, [])

  const handlerStartTimer = () => {
    updateTiemr();
    const interval = setInterval(() => {
      updateTiemr();
      if (!isFuture(new Date(endDate))) {
        clearInterval(interval);
      }
    }, 1000);
  };

  const updateTiemr = () => {
    if (!isFuture(new Date(endDate))) {
      setTimer("");
    } else {
      const duration = intervalToDuration({
        start: new Date(),
        end: new Date(endDate),
      });
      setTimer((format ?? formatDefault)(duration));
    }
  }

  return (
    <>{timer}</>
  )
}

export default Timer
